// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w67x","importantInfo":"styles_importantInfo__137na"};